import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    groupRideMessageFeatureKey,
    GroupRideMessageState,
} from './group-ride-message.reducer';

export const selectGroupRideMessage = createFeatureSelector<
    GroupRideMessageState
>(groupRideMessageFeatureKey);

export const selectGroupRideMessages = createSelector(
    selectGroupRideMessage,
    (state: GroupRideMessageState) => state.messages
);

export const selectGroupRideMessageTime = createSelector(
    selectGroupRideMessage,
    (state: GroupRideMessageState) => state.time
);

export const selectHasNewMessages = createSelector(
    selectGroupRideMessage,
    (state: GroupRideMessageState) => state.hasNewMessages
);

export const selectHasNewAlerts = createSelector(
    selectGroupRideMessage,
    (state: GroupRideMessageState) => state.hasNewAlerts
);
